import {HiOutlineArrowDown } from 'react-icons/hi';
import team from '../data/execs/team.png';
import { Card } from 'react-bootstrap';

function About() {
    const aboutBackGround = {
        background: "linear-gradient(to bottom, white 55%, pink 45%)",
        backgroundSize: "cover",
        boxSizing: "content-box",
        padding: "3%",
        paddingLeft: "20%"
    };

    const intro = "We’re the McGill Taiwanese Students Association (MTSA), the one and only Taiwanese student community on campus. Despite this, we definitely welcome students of all cultural backgrounds to join us. We strive to create a tight-knit, vibrant, and welcoming community through amazing events that showcase our rich Taiwanese culture, create spaces for meaningful cultural dialogue, and have a ton of fun while we’re at it.";

    return <div id="about" style={aboutBackGround}>
        <h1 style={{fontSize: "calc(20px + 3vw)", paddingBottom: "2%", fontFamily: "Inter, sans-serif"}}>About Us <HiOutlineArrowDown/></h1>
        <Card style={{width: "60vw", border: "none"}}>
            <Card.Img variant="top" src={team} />
            <Card.Body style={{backgroundColor: "pink"}}>
                <Card.Text style={{fontSize: "2vw", fontFamily: "Courgette, cursive", textAlign: "center"}}>{intro}</Card.Text>
            </Card.Body>
        </Card>
    </div>;
}

export default About;